<div *ngIf="loading" class="spinner-container">
  <mat-spinner></mat-spinner>
</div>

<div class="p-4 categories-container" *ngIf="!loading">
  <h2 class="text-xl font-bold mb-4">Nyereménykategóriák</h2>

  <button
    (click)="toggleForm()"
    class="mb-4 bg-blue-500 text-white px-4 py-2 rounded"
  >
    Új kategória
  </button>

  <div *ngIf="showForm" class="mb-4">
    <input
      [(ngModel)]="newCategoryName"
      placeholder="Kategória neve"
      class="border p-2 rounded mr-2"
    />
    <button
      (click)="createCategory()"
      class="bg-green-500 text-white px-4 py-2 rounded"
    >
      Mentés
    </button>
  </div>

  <mat-accordion multi>
    <mat-expansion-panel *ngFor="let category of categories">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ category.categoryName }}
        </mat-panel-title>
      </mat-expansion-panel-header>

      <!-- Ajándéklista -->
      <div *ngIf="category.gifts.length === 0" class="text-gray-500">
        Nincs még ajándék ebben a kategóriában.
      </div>

      <ul *ngIf="category.gifts.length > 0" class="space-y-2 mt-2">
        <li
          *ngFor="let gift of category.gifts"
          class="border rounded p-2 flex items-center gap-4 justify-between"
        >
          <div class="flex items-center gap-4">
            <img
              [src]="gift.imgSrc"
              alt="Ajándék képe"
              class="w-12 h-12 object-cover rounded"
            />
            <div>
              <div class="font-semibold">{{ gift.name }}</div>
              <div class="text-sm text-gray-600">Maradt: {{ gift.remaining }}</div>
            </div>
          </div>
          <button
            class="bg-red-500 text-white px-2 py-1 rounded"
            (click)="deleteGift(category.categoryName, gift)"
          >
            Törlés
          </button>
        </li>
      </ul>

      <!-- Új ajándék form -->
      <div class="mt-4 border-t pt-4">
        <h3 class="text-sm font-semibold mb-2">Új ajándék hozzáadása</h3>
        <div class="flex flex-col sm:flex-row sm:items-center gap-2">
          <input
            [(ngModel)]="newGifts[category.categoryName].name"
            placeholder="Név"
            class="border p-2 rounded w-full sm:w-1/3"
          />
          <input
            [(ngModel)]="newGifts[category.categoryName].imgSrc"
            placeholder="Kép URL"
            class="border p-2 rounded w-full sm:w-1/3"
          />
          <input
            type="number"
            min="1"
            [(ngModel)]="newGifts[category.categoryName].remaining"
            placeholder="Darabszám"
            class="border p-2 rounded w-full sm:w-1/6"
          />
          <button
            (click)="addGift(category.categoryName)"
            class="bg-blue-500 text-white px-4 py-2 rounded"
          >
            Hozzáadás
          </button>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
